const VERSION = "21.1.1";
export {
  VERSION
};
